module.exports = __webpack_public_path__ + "right-arrow-black.png?0381888533aec9865a697533145bb75b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-arrow-black.png
// module id = 688
// module chunks = 0 2 7 8 9 10